import cx from 'classnames';

import { SidebarLink } from '../../components/SidebarLink';
import { createRootProjectFolderSidebarItem } from '../../lib';
import { useActiveLocationPath } from '../../service';

import { useHandlers } from './useHandlers';
import { useStyles } from './useStyles';

const ITEM = createRootProjectFolderSidebarItem();

export const HomeItem = ({ className }) => {
  const styles = useStyles();

  const activePath = useActiveLocationPath();

  const { handleLinkClick } = useHandlers();

  return (
    <SidebarLink
      className={cx(styles.root, className)}
      classes={{ iconStart: styles.iconStart }}
      item={ITEM}
      active={ITEM.path === activePath}
      onClick={handleLinkClick}
    />
  );
};
